<script>
	export let showModal; // boolean

	let dialog; // HTMLDialogElement

	$: if (dialog && showModal) dialog.showModal();
	let y;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog class={y<700?"smallDialog":"dialog"}
	bind:this={dialog}
	on:close={() => (showModal = false)}
	on:click|self={() => dialog.close()}
>
<div class=" flex justify-end ">
	<span on:keypress class="{y<700?"text-2xl":"text-4xl"} font-bold text-white rounded-full px-3 pb-1 bg-black " on:click={() => dialog.close()}
		>x</span
	>
</div>

	<div on:click|stopPropagation>
		<slot name="header" />
		<hr />
		<slot />
		<hr />
		<!-- svelte-ignore a11y-autofocus -->
	</div>
</dialog>
<svelte:window bind:innerWidth={y}/>
<style>
	.smallDialog {
		width: 120%;
		border: none;
		padding: 0;
		background-color: transparent;
	}
	.dialog {
		width: 60%;
		border: none;
		padding: 0;
		background-color: transparent;
	}
	dialog::backdrop {
		background: rgba(0, 0, 0, 0.3);
	}
	dialog > div {
		padding: 1em;
	}
	dialog[open] {
		animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
	}
	@keyframes zoom {
		from {
			transform: scale(0.95);
		}
		to {
			transform: scale(1);
		}
	}
	dialog[open]::backdrop {
		animation: fade 0.2s ease-out;
	}
	@keyframes fade {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	span {
		display: block;
	}
</style>
